import { Grid } from '@karma/components';

const DEFAULT_COLUMN_GAP = 30;
const DEFAULT_ROW_GAP = 30;
const DEFAULT_COLUMNS = 3;

const ItemsGrid = ({
  children,
  columnGap = DEFAULT_COLUMN_GAP,
  columns = DEFAULT_COLUMNS,
  rowGap = DEFAULT_ROW_GAP,
  ...props
}) => (
  <Grid columnGap={columnGap} rowGap={rowGap} columns={columns} fullWidth {...props}>
    {children}
  </Grid>
);

export default ItemsGrid;
